import { 
    UserState,
    UserTypes,
    LOGOUT,
    LOGIN_AS_ADMIN,
    SET_LOADING,
    LOGIN_WITH_USERNAME_PASSWORD,
    LOGIN_WITH_USERNAME_PASSWORD_ERROR,
    TOGGLE_ADMIN,
    UPDATE_USER_SETTINGS,
    TOGGLE_AUTH_MODAL
} from './types';

const loginBroken = false;

const initialState : UserState = {
    access_token : "",
    token_type : "",
    expires_in : 0,
    userName : "",
    '.issued' : "",
    '.expires' : loginBroken ? "never" :"",
    isAuthenticated : loginBroken,
    roles : [],
    isAdmin : false,
    PortalSettings : {
        AllowedRoles : {
            
        }
    },
    homeProfitCenter: "",
    UserSettings : null,
    loginErrorOpen : false,
    loginErrorMessage : "",
    authModalOpen : false,
    loading : false,
    userId : "",
}

export function userReducer(
    state = initialState, 
    action : UserTypes): UserState {
        switch(action.type){
            case LOGOUT:
                return {
                    ...state,
                    access_token : "",
                    token_type : "",
                    expires_in : 0,
                    userName : "",
                    '.issued' : "",
                    '.expires' : "",
                    isAuthenticated : false,
                    isAdmin : false,
                    userId : "",
                }
            case LOGIN_AS_ADMIN:
                return {
                    ...state, 
                    ...action.payload, 
                    isAuthenticated : true, 
                    isAdmin : true
                }
            case LOGIN_WITH_USERNAME_PASSWORD:
                return {...state, ...action.payload, isAuthenticated : true, loading : false};
            case LOGIN_WITH_USERNAME_PASSWORD_ERROR:
                return { ...state, loginErrorOpen : true, loginErrorMessage : action.payload, loading : false };
            case SET_LOADING:
                return {...state, loading : action.payload};
            case TOGGLE_ADMIN:
                return {...state, isAdmin : !state.isAdmin};
            case UPDATE_USER_SETTINGS:
                return {...state, UserSettings : action.payload};
            case TOGGLE_AUTH_MODAL:
                return {...state, authModalOpen: action.payload};
            default:
                return {...state};
        }
}
